import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { endpoints } from '../../../../../environments/environment';
import { BaseResult } from '../../../../shared/models/base.result.model';
import { PixWithdrawChangeRequestModel } from '../models/pix-withdraw-change-request.model';
import { SaqueTrocoModel } from '../models/pix-withdraw-change-response.model';

@Injectable()
export class WithdrawChangeService{
	private url = endpoints.pix;

	private transferData: { description?: string, withdrawValue?: number};

	constructor(private http: HttpClient) {
		this.transferData = {};
	}

	postTransfer(model: PixWithdrawChangeRequestModel): Observable<BaseResult<SaqueTrocoModel>> {
		return this.http.post<BaseResult<SaqueTrocoModel>>(`${this.url.trasactionWithdrawChange}`, model);
	}

	setDescription(value: string) {
		this.transferData.description = value;
	}

	getDescription(): string {
		return this.transferData.description;
	}

	setValue(value: number) {
		this.transferData.withdrawValue = value;
	}

	getValue(): number {
		return this.transferData.withdrawValue;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/service/withdraw-change.service.ts